import React, { Component, useState } from 'react';
import PropTypes from 'prop-types';
import { underscored, titleize } from 'underscore.string';
import { withTranslation, useTranslation } from 'react-i18next';
import Checkbox from '../../v2/forms/Checkbox';
import Badge from '../../v2/Badge';
import CargomaticInput from '../../v2/input';
const NotificationField = ({ onCheckboxChange, onRecipientsUpdateList, onAddRecipients, checked, label, recipients = [], id, }) => {
    const { t } = useTranslation();
    const [inputValue, setInputValue] = useState('');
    async function handleOnAddRecipients() {
        if (!recipients.includes(inputValue)) {
            recipients.push(inputValue);
            // update the recipients list then call save
            await onRecipientsUpdateList(recipients);
            await onAddRecipients();
        }
        // make input field empty after save.
        setInputValue('');
    }
    async function removeValue(recipient) {
        // remove email from recipients
        recipients = recipients.filter((el) => !el.includes(recipient));
        await onRecipientsUpdateList(recipients);
        await onAddRecipients();
    }
    const placeholder = label.indexOf('mail') > -1 ? t('ENTER_EMAILS') : t('ENTER_TEXTS');
    return (React.createElement("div", null,
        React.createElement("div", { className: "mb-1" },
            React.createElement(Checkbox, { id: id, checked: checked, onChange: onCheckboxChange, label: label })),
        checked && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "flex items-center justify-between" },
                React.createElement(CargomaticInput, { className: "w-full", hideLabel: true, onChange: (value) => setInputValue(value), value: inputValue, placeholder: placeholder, type: "text" }),
                React.createElement("button", { onClick: () => handleOnAddRecipients(), className: "ml-2 button button-hollow-green w-1/4" }, titleize(t('ADD')))),
            React.createElement("div", { className: "mb-3" }, (recipients || []).map((recipient) => (React.createElement(Badge, { className: "mt-1", onRemove: () => removeValue(recipient), withRemove: true, text: recipient, key: recipient }))))))));
};
class Notification extends Component {
    renderMessage(message) {
        const { t } = this.props;
        let label = message.split(' ').join('_').toUpperCase();
        return t(label);
    }
    render() {
        const { notificationType: { message, email, text }, t, } = this.props;
        const emailHidden = typeof email.hidden === 'undefined' ? false : email.hidden;
        const textHidden = typeof text.hidden === 'undefined' ? false : text.hidden;
        const prefix = underscored(message);
        const emailId = `${prefix}_email`;
        const textId = `${prefix}_text`;
        return (React.createElement("div", { className: "notification-type grid lg:grid-cols-6 lg:gap-x-6" },
            React.createElement("div", { className: "font-medium leading-6 lg:col-span-6 mb-1" }, this.renderMessage(message)),
            !emailHidden && (React.createElement("div", { className: "lg:col-span-3" },
                React.createElement(NotificationField, { id: emailId, checked: !email.silent, onCheckboxChange: this.props.onEmailNotificationChange, onRecipientsUpdateList: this.props.onEmailRecipientsChange, onAddRecipients: this.props.onEmailRecipientsBlur, recipients: email.value, label: t('EMAIL') }))),
            !textHidden && (React.createElement("div", { className: "lg:col-span-3" },
                React.createElement(NotificationField, { id: textId, checked: !text.silent, onCheckboxChange: this.props.onTextNotificationChange, onRecipientsUpdateList: this.props.onTextRecipientsChange, onAddRecipients: this.props.onTextRecipientsBlur, recipients: text.value, label: t('TEXT') })))));
    }
}
Notification.propTypes = {
    notificationType: PropTypes.shape({
        message: PropTypes.string.isRequired,
        email: PropTypes.shape({
            silent: PropTypes.bool.isRequired,
            recipients: PropTypes.arrayOf(PropTypes.string),
        }).isRequired,
        text: PropTypes.shape({
            silent: PropTypes.bool.isRequired,
            recipients: PropTypes.arrayOf(PropTypes.string),
        }).isRequired,
    }).isRequired,
    onEmailNotificationChange: PropTypes.func.isRequired,
    onEmailRecipientsChange: PropTypes.func.isRequired,
    onTextNotificationChange: PropTypes.func.isRequired,
    onTextRecipientsChange: PropTypes.func.isRequired,
    onEmailRecipientsBlur: PropTypes.func.isRequired,
    onTextRecipientsBlur: PropTypes.func.isRequired,
};
export default withTranslation()(Notification);
